import * as React from 'react';

import { TRADEWING_APP_LOGO_SRC } from '@/modules/mobile-app/appStoreLinks';

import styles from './DownloadApp.module.css';

const CHIPS = [
  { icon: '💬', label: 'Community', className: styles.c1 },
  { icon: '📅', label: 'Events', className: styles.c2 },
  { icon: '👥', label: 'Members', className: styles.c3 },
  { icon: '🤝', label: 'Sponsors', className: styles.c4 },
  { icon: '🛡️', label: 'Admin Site', className: styles.c5 },
];

/** Left column of the "Download app" onboarding step: phone mock + feature chips. Decorative only. */
export const AppShowcase: React.FC = () => (
  <section className={styles.show} aria-hidden="true">
    <div className={styles.brand}>
      <span className={styles.logoTile}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={TRADEWING_APP_LOGO_SRC} alt="" />
      </span>
      TradewingLLC
    </div>

    <div className={styles.stage}>
      <div className={`${styles.ring} ${styles.ring2}`} />
      <div className={styles.ring} />
      <div className={styles.halo} />

      <div className={styles.phone}>
        <div className={styles.screen}>
          <div className={styles.island} />
          <div className={styles.status}>
            <span>2:08</span>
            <span>5G ▮▮▮</span>
          </div>
          <div className={styles.appbar}>
            ☰ Community
            <span className={styles.appbarIcons}>
              <b />
              <b />
              <span className={styles.avatar} />
            </span>
          </div>
          <div className={styles.tabs}>
            <span className={styles.tabOn}>Feed</span>
            <span>Announcement</span>
            <span>Quick Meeting</span>
            <span>Groups</span>
          </div>
          <div className={styles.post}>
            <div className={styles.who}>
              <span className={styles.whoAvatar} />
              <div>
                James Taylor<em>2 Nov 2026</em>
                <small>Posted in Member Group</small>
              </div>
            </div>
            <h5>✨ What makes Tradewing special?</h5>
            <ul>
              <li>
                <b>Community Engagement</b> – Build stronger connections and
                encourage meaningful interactions.
              </li>
              <li>
                <b>Event Management</b> – Manage events and create seamless
                experiences for participants.
              </li>
              <li>
                <b>Member Management</b> – Keep your community connected and
                organized.
              </li>
              <li>
                <b>Sponsor Management</b> – Strengthen sponsor relationships and
                collaboration.
              </li>
              <li>
                <b>Smart Communication</b> – Keep members informed with
                streamlined notifications.
              </li>
              <li>
                <b>AI-Powered Experience</b> – Make information discovery
                smarter and easier.
              </li>
            </ul>
            <p className={styles.goal}>
              Our goal is simple: empower organizations with technology that
              makes community management smarter, easier, and more connected.
            </p>
            <p className={styles.plat}>
              🌐 One Platform. Stronger Connections. Endless Possibilities.
            </p>
            <div className={styles.postImg} />
            <div className={styles.postActions}>
              <span>👍 Like</span>
              <span>💬 Comment</span>
            </div>
          </div>
          <div className={styles.fab}>+</div>
          <div className={styles.nav}>
            <span className={styles.navOn}>
              ⌂<br />
              Community
            </span>
            <span>
              ▦<br />
              Events
            </span>
            <span>
              ☺<br />
              Members
            </span>
            <span>
              $<br />
              Sponsors
            </span>
          </div>
        </div>
      </div>
    </div>

    {CHIPS.map((chip) => (
      <div key={chip.label} className={`${styles.chip} ${chip.className}`}>
        <span className={styles.chipIcon}>{chip.icon}</span>
        {chip.label}
      </div>
    ))}
  </section>
);
